import CommonService from './common.service'

class AuthService extends CommonService {
  async register(params: { [key: string]: string }) {
    return await this.post('/register', params)
  }

  async accountVarification(params: { [key: string]: string }, toastify = false) {
    return await this.post('/account-verification', params, toastify)
  }

  async login(params: { [key: string]: string }, toastify = false) {
    return await this.post('/login', params, toastify)
  }

  async forgotPassword(params: { [key: string]: string }) {
    return await this.post('/reset-password-email', params)
  }

  async updatePassword(params: { [key: string]: string | null }) {
    return await this.post('/update-password', params)
  }

  async changePassword(params: { [key: string]: string }) {
    return await this.post('/change-password', params)
  }

  async resendVerificationEmail(params: { [key: string]: string }) {
    return await this.post('/resend-verification', params)
  }

  async getMe() {
    return await this.get('/me')
  }

  async deleteAccount() {
    return await this.delete('/profile')
  }

  async sendWelcomeEmail(params: { [key: string]: string }) {
    return await this.post('/send-welcome-email', params)
  }
}

export const authService = new AuthService()
